import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Overlay } from './index';

import Error from './img/error@2x.png';
import Success from './img/verified@2x.png';
import './index.scss';

export default function ValidationStatusModal(props) {
  const { visibility, status, onClose, successMessage, errorMessage } = props;

  const onContentClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <div className={classnames('modal', { open: visibility })} >
      <Overlay onOverlayClick={onClose}>
        <a href="" className="validation-status" onClick={onContentClick}>
          {
            status ?
              <img src={Success} alt="presentation" width="55" /> :
              <img src={Error} alt="presentation" width="55" />
          }
          {
            status ?
              <h4>{successMessage}</h4> :
              <h4>{errorMessage}</h4>
          }
        </a>
      </Overlay>
    </div>
  );
}

ValidationStatusModal.defaultProps = {
  onClose: () => {},
  visibility: false, // Hidden
  status: false, // Error
  successMessage: 'Saved',
  errorMessage: 'Oops! There was some error, please try again later',
};

ValidationStatusModal.propTypes = {
  onClose: PropTypes.func,
  visibility: PropTypes.bool,
  status: PropTypes.bool,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
};
